import { AdminWithdrawalsScreen } from '@features/admin/ui/AdminWithdrawalsScreen'
import { PermissionGate } from '@shared/ui/PermissionGate'

export function SaquesPage() {
  return (
    <PermissionGate permission="PAYOUT_READ">
      <AdminWithdrawalsScreen />
    </PermissionGate>
  )
}
